import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  persistSessionTerminalContext,
  type SessionTerminalContext,
} from '@/lib/sessionTerminal';
import { recordTableSessionTerminal } from '@/lib/sessionTerminalTelemetry';
import { clearTableSession } from '@/lib/tableContext';

export function useSessionTermination(
  terminal: SessionTerminalContext | null,
): void {
  const navigate = useNavigate();
  const handledEventIdsRef = useRef(new Set<string>());

  useEffect(() => {
    if (!terminal || handledEventIdsRef.current.has(terminal.eventId)) return;

    handledEventIdsRef.current.add(terminal.eventId);

    try {
      persistSessionTerminalContext(terminal);
    } catch {
      // Storage failure must not interrupt terminal cleanup or navigation.
    }

    try {
      recordTableSessionTerminal(terminal);
    } catch {
      // Telemetry failure must not interrupt terminal cleanup or navigation.
    }

    try {
      clearTableSession();
    } catch {
      // Cleanup failure must not prevent the dedicated terminal screen.
    }

    try {
      navigate('/session-expired', {
        replace: true,
        state: { terminal },
      });
    } catch {
      // Router failure must not escape the terminal side-effect boundary.
    }
  }, [navigate, terminal]);
}
